import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import styles from './DealsDistributionChart.module.scss'

ChartJS.register(ArcElement, Tooltip, Legend)

const DealsDistributionChart = ({
  leftArray = [], // Статусы (слева) - с полем color
  rightArray = [], // Менеджеры (справа)
  totalCount = 0, // Общее количество сделок
  totalLabel = 'Всего сделок',
  managersColumns = 2, // Количество колонок (по умолчанию 2)
}) => {
  // Разбиваем менеджеров на колонки
  const splitManagersIntoColumns = (managers, numColumns) => {
    const columns = Array.from({ length: numColumns }, () => [])
    managers.forEach((manager, index) => {
      const columnIndex = index % numColumns
      columns[columnIndex].push(manager)
    })
    return columns
  }

  const managerColumns = splitManagersIntoColumns(rightArray, managersColumns)

  // Подготовка данных для диаграммы
  const chartData = {
    labels: leftArray.map((item) => item.label),
    datasets: [
      {
        data: leftArray.map((item) => item.procent),
        backgroundColor: leftArray.map((item) => item.color),
        borderWidth: 0,
      },
    ],
  }

  // Опции для диаграммы
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          title: function (tooltipItems) {
            if (tooltipItems.length > 0) {
              const index = tooltipItems[0].dataIndex
              return leftArray[index]?.label || ''
            }
            return ''
          },
          label: function (context) {
            const value = context.parsed
            return `${value}%`
          },
        },
      },
      legend: {
        display: false,
      },
    },
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {/* Левая колонка - статусы */}
        <div className={styles.column}>
          {leftArray.map((item, index) => (
            <div key={index} className={styles.item}>
              <div className={styles.percentage}>{item.procent}%</div>
              <div
                className={styles.line}
                style={{ backgroundColor: item.color }}
              />
              <div className={styles.labelBox}>
                <div className={styles.label}>{item.label}</div>
                <span className={styles.count}>{item.value} сделок</span>
              </div>
            </div>
          ))}
        </div>

        {/* Центральная часть - диаграмма */}
        <div className={styles.chartWrapper}>
          <div className={styles.chartCenter}>
            <div className={styles.totalCount}>{totalCount}</div>
            <div className={styles.totalLabel}>{totalLabel}</div>
          </div>
          <Doughnut data={chartData} options={options} />
        </div>

        {/* Правая часть - менеджеры в несколько колонок */}
        <div className={styles.managersColumns}>
          {managerColumns.map((column, columnIndex) => (
            <div key={columnIndex} className={styles.managerColumn}>
              {column.map((item, index) => {
                const globalIndex = columnIndex + index * managerColumns.length
                return (
                  <div key={index} className={styles.item}>
                    <div className={styles.percentage}>{item.procent}%</div>
                    <div
                      className={styles.line}
                      style={{
                        backgroundColor:
                          leftArray[globalIndex % leftArray.length]?.color ||
                          'rgb(201, 203, 207)',
                      }}
                    />
                    <div className={styles.labelBox}>
                      <div className={styles.label}>{item.label}</div>
                      <span className={styles.count}>{item.value} сделок</span>
                    </div>
                  </div>
                )
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DealsDistributionChart
